import { useRef } from 'react';
import { toast } from 'react-toastify';
import { WinningToast, WinningToastProps } from '../WinningToast';
import styles from '../WinningToast.module.scss';
import {
  greatWinSlugs,
  TGreatWinSlugWithWinAmount,
  TLeaguesSlugWithWinAmount,
} from './types';
import { useJackpotPolling } from './useJackpotPolling';

const showWinningToast = (props: WinningToastProps) =>
  toast(() => <WinningToast {...props} />, {
    closeButton: false,
    className: styles.wtModal,
    progressClassName: styles.wtProgressbar,
    autoClose: 10000,
  });

export const useJackpotNotifier = () => {
  const shownJackpotSlugs = useRef<Set<string>>(new Set());

  const handleJackpots = (jackpotList: { jackpotSlug: string; winAmount: string }[]) => {
    // чистим useRef при каждом запорсе
    shownJackpotSlugs.current.clear();

    const newSlugs = new Set<string>();
    const leagues: TLeaguesSlugWithWinAmount[] = [];
    const greatWins: TGreatWinSlugWithWinAmount[] = [];

    jackpotList.forEach(({ jackpotSlug, winAmount }) => {
      if (!winAmount || Number(winAmount) <= 0) return;
      if (shownJackpotSlugs.current.has(jackpotSlug)) return;

      newSlugs.add(jackpotSlug);

      const jackpotData = { slug: jackpotSlug as any, amount: winAmount };

      if (greatWinSlugs.includes(jackpotSlug as any)) {
        greatWins.push(jackpotData);
      } else {
        leagues.push(jackpotData);
      }
    });

    if (leagues.length > 0) {
      showWinningToast({ leaguesSlugsWithWinAmount: leagues });
    }

    for (const greatWin of greatWins) {
      showWinningToast({ greatWinSlugWithWinAmount: greatWin });
    }

    for (const slug of newSlugs) {
      shownJackpotSlugs.current.add(slug);
    }
  };

  useJackpotPolling(handleJackpots);
};
